import script from "./RoomsManager.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomsManager.vue?vue&type=script&setup=true&lang=js"

import "./RoomsManager.vue?vue&type=style&index=0&id=5912cd95&scoped=true&lang=scss"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5912cd95"]])

export default __exports__